import React from 'react'
import Link from 'gatsby-link'

import GlobalPropsProvider from '../utils/stateProvider'

import HeaderSpacer from '../global/header-spacer'
import ArticleFilterSort from '../header/articleFilterSort'

import ExcerptList from './excerptList'
import PostExcerpt from './excerpt'
import Navigation from '../navigation'

import globalState from '../../helpers/globalState'
import buildLink from '../../helpers/linkBuilder'
import { parseQuery } from '../../helpers/filterSort'
import { translate } from '../../helpers/stringTranslation'

import Styles from '../../styles/components/post.module.scss'
const { postTileContainer, postSingleSeeMore } = Styles

const getSortFn = sortBy => {
  switch (sortBy) {
    case 'oldest':
      return (a, b) => {
        return a.dateObj - b.dateObj
      }
    case 'most-popular':
      return (a, b) => b.popularity - a.popularity
    case null:
      return (a, b) => {
        return b.dateObj - a.dateObj
      }
    case 'default':
      return 0
  }
}

class ArticlesArchive extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      showText: true,
    }

    this.articles =
      this.props.data && this.props.data.articles
        ? this.props.data.articles.edges.map(edge => ({
            ...edge.node,
            dateObj: new Date(edge.node.date),
          }))
        : []
  }

  onMountGlobalState(state) {
    return {
      ...state,
      whiteLogo: false,
    }
  }

  render() {
    const { sort, filter, archive, windowWide } = this.props

    const articles = this.articles
      .filter(article => {
        return (
          (filter === null ||
            article.categories.filter(cat => cat.slug === filter).length > 0) &&
          (archive === null || article.fields.date_archive === archive)
        )
      })
      .sort(getSortFn(sort))

    let archiveHeader = null

    if (archive) {
      const [year, month] = archive.split('-')
      archiveHeader = (
        <div className={postSingleSeeMore}>{`${
          translate('months')[parseInt(month, 10) - 1]
        } ${year}`}</div>
      )
    }
    // windowWidth > 1200
    return (
      <div>
        <HeaderSpacer />
        {!windowWide && <ArticleFilterSort inHeader={false} />}
        {archiveHeader}
        <ExcerptList
          flip
          onFlipStart={() => {
            this.setState({ showText: false })
          }}
          onFlipFinish={() => {
            this.setState({ showText: true })
          }}
          className={postTileContainer}
        >
          {articles.map((article, index) => {
            return (
              <PostExcerpt
                data={article}
                featured={index === 0}
                key={article.slug}
                showText={this.state.showText}
              />
            )
          })}
        </ExcerptList>
        <Navigation />
      </div>
    )
  }
}

export default GlobalPropsProvider(ArticlesArchive, state => ({
  filter: state.articleFilter,
  sort: state.articleSort,
  archive: state.articleArchive,
  windowWide: state.windowWidth > 1200,
}))



// WEBPACK FOOTER //
// ./src/components/post/archive.js